module.exports = __webpack_public_path__ + "static/media/dronacharya.59afd011.png";